<template>
  <a-row :gutter="24" class="new-row">
    <a-col :md="collapsed?0: 5" :sm="24" class="new-col">
      <a-card :bordered="false" class="new-tree-card">
          <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
            <a-alert type="info" :showIcon="true">
              <div slot="message">
                {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
                <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
              </div>
            </a-alert>
            <div style="display: flex;margin-top: 10px;">
              <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')"/>
              <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
            </div>
            <!-- 树-->
            <a-col :md="24" :sm="24" class="new-tree-col">
              <template>
                <a-spin tip="Loading..." :spinning="areaLoading">
                  <!--
                  <span style="user-select: none">
                    <a-tree
                      class="my-area-select-tree"
                      @select="onSelect"     
                      :selectedKeys="selectedKeys"
                      :treeData="areaTree"
                      :checkStrictly="checkStrictly"
                      :expandedKeys="iExpandedKeys"
                      :autoExpandParent="autoExpandParent"
                      @expand="onExpand">
                      <template slot="title" slot-scope="{title}">
                        <span v-if="title.indexOf(searchAreaValue) > -1">
                          {{title.substr(0, title.indexOf(searchAreaValue))}}
                        <span style="color: #32CD32">{{searchAreaValue}}</span>
                          {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                        </span>
                        <span v-else>{{title}}</span>
                      </template>
                    </a-tree>
                  </span>
                  -->
                  <el-tree
                    class="filter-tree"
                    :data="areaTree"
                    :props="defaultProps"
                    :expand-on-click-node="false"
                    :filter-node-method="filterNode"
                    :check-on-click-node="true"
                    :check-strictly="checkStrictly"
                    :highlight-current="true"
                    node-key="id"
                    :current-node-key="currentNodeKey"
                    :default-expanded-keys="iExpandedKeys"
                    @node-click="nodeClick"
                    ref="areaTree">
                  </el-tree>
                </a-spin>
              </template>
            </a-col>
          </div>
      </a-card>
    </a-col>
    <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
      <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
        @click="collapsed = !collapsed"
        class="area-collapsed"></a-icon>
      <a-card :bordered="false" class="new-table-card">
        <a-tabs default-active-key="1" @change="callback" class="new-tabs">
          <a-tab-pane key="1" :tab="$t('用户信息')">
            <!-- 查询区域 -->
            <div class="table-page-search-wrapper">
              <a-form layout="inline" @keyup.enter.native="searchQuery">
                <a-row :gutter="24">
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item :label="$t('表编号')">
                      <a-input :placeholder="$t('请输入表编号')" v-model="queryParam.meterId"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item :label="$t('用户编号')">
                      <a-input :placeholder="$t('请输入用户编号')" v-model="queryParam.userId"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <a-form-item :label="$t('用户姓名')">
                      <a-input :placeholder="$t('请输入用户姓名')" v-model="queryParam.userName"></a-input>
                    </a-form-item>
                  </a-col>
                  <template v-if="toggleSearchStatus">
                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                      <a-form-item :label="$t('用户手机')">
                        <a-input :placeholder="$t('请输入用户手机')" v-model="queryParam.userPhone"></a-input>
                      </a-form-item>
                    </a-col>
                    <a-col :xl="12" :lg="7" :md="8" :sm="24">
                      <a-form-item :label="$t('电压范围')">
                        <a-input-group compact>
                          <a-input v-model="queryParam.minValue" style=" width: 120px; text-align: center" :placeholder="$t('电压值最小值')" />
                          <a-input
                            style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff"
                            placeholder="~"
                            disabled
                          />
                          <a-input v-model="queryParam.maxValue" style="width: 120px; text-align: center; border-left: 0" :placeholder="$t('电压值最大值')" />
                        </a-input-group>
                      </a-form-item>
                    </a-col>
                  </template>
                  <a-col :xl="6" :lg="7" :md="8" :sm="24">
                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                      <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                      <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                      <a @click="handleToggleSearch" style="margin-left: 8px">
                        {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                        <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                      </a>
                    </span>
                  </a-col>
                </a-row>
              </a-form>
            </div> 
            <!-- 操作按钮区域 -->
            <div class="table-operator">
              <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
              <a-button type="primary" icon="download" @click="handleExportXls($t('电池电压'))">{{ $t('导出') }}</a-button>
            </div> 
            <div class="table-fixed">
            <a-table
              ref="table"
              size="middle"
              tableLayout="fixed"
              :scroll="{ x: 1400 }"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              class="j-table-force-nowrap"
              :components="drag(columns)"
              @change="handleTableChange">
              <span slot="action" slot-scope="text, record">
                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              </span>
            </a-table>
            </div>
          </a-tab-pane>
          <a-tab-pane key="2" :tab="$t('电池电压图形分析')" force-render class="new-tab-pane-block">
            <a-col :xl="12" :lg="24" :md="24" :sm="24" :xs="24">
            <pie-chat :title="$t('电池电压分析')"  :dataSource="DayPieData" :fields="DayPieFields" :style="{ padding: '0 0 0px 0px' }" />
            </a-col>
            <a-col :xl="12" :lg="24" :md="24" :sm="24" :xs="24">
              <a-row>
                <a-col :span="12" v-for="(item,index) in DayPieData" :key="index">
                
                  <div class="flex flex-center" style="margin-bottom: 15px">
                    <div class="flex-item" style="height: 100px" >
                      <div class="flex-center" style="height: 100%;background: #e6f7ff;border: 1px solid #91d5ff;flex-direction: column;">
                        <div class="flex-center">
                          <span class="" style="margin-left:10px;font-size:28px;font-weight: 500">{{item.count}}</span>
                          <span class="unit" style="color: #999999">{{ $t('个') }}</span>
                          </div>
                        <div class="flex-center" style="color: #999999">{{item.item}}</div>
                      </div>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </a-col>
          </a-tab-pane>
        </a-tabs>
        <meter-up-data-analysis-modal ref="modalForm" @ok="modalFormOk"></meter-up-data-analysis-modal>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import MeterUpDataAnalysisModal from './modules/MeterUpDataAnalysisModal'
  import { getAction } from '@/api/manage'
  import { isUndefined } from'@/utils/validate'
  import { listSize } from '@/utils/util'
  import TableDragResize  from '@/mixins/TableDragResize'

  import PieChat from './modules/PieChat'
  export default {
    name: 'MeterUpDataAnalysisList',
    mixins:[JeecgListMixin, mixinDevice, AreaChoosetMixin,TableDragResize],
    components: {
      MeterUpDataAnalysisModal,
      PieChat,
    },
    data () {
      return {
        description: 'meter_up_data_analysis管理页面',
        collapsed: false,
        tabs:'',
        DayPieData: [],
        url: {
          list: "/jeecg-charge/meter/meterUpDataAnalysis/meterVoltageList",
          delete: "/jeecg-charge/meter/meterUpDataAnalysis/delete",
          deleteBatch: "/jeecg-charge/meter/meterUpDataAnalysis/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterUpDataAnalysis/voltageExportXls",  //导出接口
          importExcelUrl: "jeecg-charge/meter/meterUpDataAnalysis/importExcel",
          voltageInterval:"/jeecg-charge/meter/meterUpDataAnalysis/voltageInterval"
        },
        voltageInterval:[],
        dictOptions:{},
      }
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：图例使用 computed 以响应语言切换
      DayPieFields () {
        return ['昨日', '今日'].map(item => this.$t(item))
      },
      // i18n：表头使用 computed 以响应语言切换
      columns () {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t, r, index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex: 'userName',
            width:150,
            ellipsis: true
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width:150,
            ellipsis: true
          },{
            title: this.$t('表类型'),
            align:"center",
            dataIndex: 'mtCodeName',
            width:100,
            ellipsis: true
          },{
            title: this.$t('用户手机号'),
            align:"center",
            dataIndex: 'userPhone',
            width:150,
            ellipsis: true
          },{
            title: this.$t('用户地址'),
            align:"center",
            dataIndex: 'userAddr',
            ellipsis: true,
            width:150,
            customRender: (t, r, index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
          },{
            title: this.$t('电池状态'),
            align:"center",
            dataIndex: 'meterBatteryStatus',
            customRender: (t, r, index) => {
              let data = {"0": this.$t("正常"),"1": this.$t("欠压")}
              if(isUndefined(typeof data[t])) {
                return this.$t("其他")
              }
              return data[t]
            },
            width:100,
            ellipsis: true
          },{
            title: this.$t('电池电压(V)'),
            align:"center",
            dataIndex: 'meterBatteryVoltage',
            width:100,
            ellipsis: true
          },{
            title: this.$t('系统时间'),
            align:"center",
            dataIndex: 'sysTime',
            width:150,
            ellipsis: true
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:100,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      queryvoltageInterval() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        params.areaId = this.queryParam.areaId
        console.log(this.queryParam);
        console.log(params);
        getAction(this.url.voltageInterval, params).then((res) => {
          if(res.success){
            this.voltageInterval = res.result;
            this.DayPieData =[
              { item: '≥3.4v', count: this.voltageInterval.valtage1MeterCount },
              { item: '3.1v-3.4v', count: this.voltageInterval.valtage2MeterCount },
              { item: '2.9v-3.1v', count: this.voltageInterval.valtage3MeterCount },
              { item: '<2.9v', count: this.voltageInterval.valtage4MeterCount },
            ]
            console.log(this.voltageInterval);
          }
        }) 
      },
      callback(key) {
        this.tabs = key;
        if (key==1) {
          this.loadData()
        } if (key==2) {
          this.queryvoltageInterval();
          this.refresh();
        }
        console.log(key);
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
  .tables{
    width: 88%;
  }
  .fontsize{
    font-size:20px
  }
</style>